/* eslint-disable react/prop-types */
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";
import Grid from "@mui/material/Grid";

function Details({ property }) {
  return (
    <>
      <br />
      <Grid container item xs={12} justifyContent="center" mx="auto">
        <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <MKTypography variant="h3">{property?.name}</MKTypography>
        </MKBox>
      </Grid>

      <table>
        <tr>
          <td>
            <MKTypography variant="body1" fontSize="17px" fontWeight="light" color="inherit">
              <span className="material-icons-outlined">location_on</span>
              Dirección
            </MKTypography>
            <span className="details">{property?.street}</span>
            <br />
            <span className="details">{property?.suburb?.name}</span>
          </td>
        </tr>
        <tr>
          <td>
            <MKTypography variant="body1" fontSize="17px" fontWeight="light" color="inherit">
              <span className="material-icons-outlined">account_balance</span>
              Actividad Económica
            </MKTypography>
            <span className="details">{property.business_activity?.name}</span>
          </td>
        </tr>
        <tr>
          <td>
            <MKTypography variant="body1" fontSize="17px" fontWeight="light" color="inherit">
              <span className="material-icons-outlined">data_exploration</span>
              &nbsp;Valor Cultural
            </MKTypography>
            <span className="details">{property?.cultural_value}</span>
          </td>
        </tr>
      </table>
    </>
  );
}

export default Details;
